export default {
  session: {
    id: null,
    status: 'idle',
    progress: 0,
    currentStep: '',
  },
  selectedForms: [],
  selectedPatients: [],
  patientsList: [],
  configuration: {
    analysisType: 'summary',
    selectedTemplateId: null,
    selectedTemplate: null,
    dateFilter: {
      startDate: null,
      endDate: null,
      period: 'last30days',
    },
    clientFilter: {
      selectedClients: [],
      filterEnabled: false,
    },
    documentConfig: {
      name: '',
      folderId: null,
      categoryId: null,
    },
  },
  formsList: [],
  reportTemplates: [],
  formAnswers: {},
  generatedContent: null,
  createdDocument: null,
  websocket: {
    connected: false,
    error: null,
  },
  fetching: {
    createSession: false,
    fetchForms: false,
    fetchAnswers: false,
    generateReport: false,
    createDocument: false,
    fetchTemplates: false,
  },
  error: null,
};
